import './styles.scss';
import React from 'react';
import { data } from './mockData';
import TeamMemberCard from './TeamMemberCard';
import TeamCareerCard from './TeamCareerCard';
import TeamInfoCard from './TeamInfoCard';
import { ReactComponent as Icon1 } from 'assets/icons/teamcard-1.svg';
import { ReactComponent as Icon2 } from 'assets/icons/teamcard-2.svg';

const Cards = ({ index }) => (
    <>
        {index === 2 && <TeamInfoCard number="50+" text="experts in agronomy and biotechnology" icon={<Icon1 />} />}
        {index === 3 && <TeamInfoCard number="22+" text="years in agricultural industry" icon={<Icon2 />} />}
    </>
);

const TeamsCards = () => (
    <div className="team">
        {data.map((item, index) => (
            <React.Fragment key={item.name}>
                <TeamMemberCard data={item} />
                <Cards index={index} />
            </React.Fragment>
        ))}
        <TeamCareerCard />
    </div>
);

export default TeamsCards;
